import { ApiService } from "@/domain/clients";
import { CreateSharedAppointmentSlotInput } from "@/domain/dtos/inputs";
import { NotFoundError } from "@/domain/errors";
import { Endpoints } from "@/infra/api";
import { SharedAppointmentSlotResponse } from "@/data/dtos/responses";
import { SharedAppointmentSlotDataSource } from "./SharedAppointmentSlotDataSource";

export class SharedAppointmentSlotRemoteDataSource
  implements SharedAppointmentSlotDataSource
{
  constructor(private readonly api: ApiService) {}

  async createSharedAppointmentSlot(
    params: CreateSharedAppointmentSlotInput,
  ): Promise<SharedAppointmentSlotResponse> {
    const { data } = await this.api.post<
      SharedAppointmentSlotResponse,
      CreateSharedAppointmentSlotInput
    >(Endpoints.shared_appointment_slots, params);

    if (!data) throw new NotFoundError("Horário compartilhado");

    return data;
  }
}
